module.exports = __webpack_public_path__ + "img/icn_user.e346e8b2.svg";